<crowdctrl-page pageTitle="Page Not Found" [showFooter]="false" defaultHref="/">
  <div style="text-align: center; padding: 2rem">
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you are looking for does not exist.</p>
    <ion-button (click)="goHome()" fill="solid" color="primary"> Go Home </ion-button>
  </div>
</crowdctrl-page>
